import { LoadableDocumentsWork } from "features";
import React from "react";
import { Breadcrumb } from "shared/ui/components";

export default function DocumentsWorkPage() {
  return (
    <>
      <Breadcrumb
        preCrumb={{ text: "myWork", link: "/documents" }}
        listPath={["/myTasks"]}
      />
      <LoadableDocumentsWork />
    </>
  );
}
